import {
  SSO_ERROR_EMAIL,
  SSO_ERROR_KEY,
  SSO_TOKEN_KEY,
  WAIT_FOR_KEYS_IN_LOCAL_STORAGE_INTERVAL,
} from "modules/auth/constants";
import { FirebaseAuthError } from "testUtils/error";

const waitForTokenInLocalStorage = (): Promise<string> =>
  new Promise((resolve, reject) => {
    const timer = setInterval(() => {
      const token = localStorage.getItem(SSO_TOKEN_KEY);
      const error = localStorage.getItem(SSO_ERROR_KEY);

      if (error) {
        clearInterval(timer);
        localStorage.removeItem(SSO_ERROR_KEY);

        const errorEmail = localStorage.getItem(SSO_ERROR_EMAIL);

        if (errorEmail) {
          localStorage.removeItem(SSO_ERROR_EMAIL);
          reject(
            new FirebaseAuthError(error, {
              email: errorEmail,
            }),
          );
        }

        reject(new Error(error));
      }

      if (token) {
        clearInterval(timer);
        localStorage.removeItem(SSO_TOKEN_KEY);

        resolve(token);
      }
    }, WAIT_FOR_KEYS_IN_LOCAL_STORAGE_INTERVAL);
  });

export default waitForTokenInLocalStorage;
